export const SIGNAL_KINDS = [['positive','Positiva'],['attention','Attenzione'],['problem','Problema']];
export const SIGNAL_REASONS = [['damage','Danno rilevato'],['delay','Ritardo'],['payment','Problema di pagamento'],['good_experience','Buona esperienza'],['other','Altro']];
export const emptySignal = () => ({kind:'',reason:'',description:'',location_id:'',damage_refs:[]});
export function signalErrors(value) {
  const f=value||{},errors=[];
  if(!SIGNAL_KINDS.some(([key])=>key===f.kind))errors.push('Scegli il tipo di segnalazione.');
  if(!SIGNAL_REASONS.some(([key])=>key===f.reason))errors.push('Scegli il motivo della segnalazione.');
  if(!f.description?.trim()||f.description.length>2000)errors.push('Descrivi la segnalazione (da 1 a 2000 caratteri).');
  if(!f.location_id)errors.push('Scegli la sede della segnalazione.');
  return errors;
}
export function signalCounts(rows=[]) {
  return rows.reduce((counts,row)=>{if(row.status==='active'&&row.kind in counts)counts[row.kind]++;else counts.inactive++;return counts;},{positive:0,attention:0,problem:0,inactive:0});
}
export const activeSignalCount = counts => ['positive','attention','problem'].reduce((n,key)=>n+(counts?.[key]||0),0);
export function matchesSignalFilter(counts,filter) {
  if(filter==='all')return true;
  if(filter==='none')return activeSignalCount(counts)===0;
  return (counts?.[filter]||0)>0;
}
export function signalDamageChoices(rental, pending=[]) {
  const parts=[...(rental?.vehicle_segments||[]),rental||{}];
  const recorded=parts.flatMap(part=>(part.damage_inspections||[]).flatMap(i=>(i.items||[]).map(item=>({item,inspection_id:i.id,operation:i.operation}))));
  return [...recorded,...pending.map(item=>({item,operation:'restituzione'}))];
}
export function validSignalDraft(f) {
  return !!f && typeof f==='object' && ['kind','reason','description','location_id'].every(k=>typeof f[k]==='string') && Array.isArray(f.damage_refs) && f.damage_refs.every(r=>r&&typeof r.damage_id==='string'&&(r.inspection_id===undefined||typeof r.inspection_id==='string'));
}
